import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { MustMatch } from '@app/components/members/changepassword/changepassword.component';
import { ResetpasswordService } from '@app/services/resetpassword.service';
import { Subscription } from 'rxjs';
import { OidcSecurityService } from "angular-auth-oidc-client";
@Component({
  selector: 'app-resetpassword2',
  templateUrl: './resetpassword2.component.html'
})
export class Resetpassword2Component implements OnInit {
  token: string;
  username: string;
  confirmpwshow = false;
  pwshow = false;
  passwordform;
  
  subscriptions: Subscription[] = [];
  display = false;
  errorlist: string[] = [];
  type = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private oidcSecurityService: OidcSecurityService,
    private resetpasswordService: ResetpasswordService) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['token'];
      this.username = params['userId'];
    });
  }

  ngOnInit(): void {
    this.passwordform = this.fb.group({
      password: ['', Validators.required],
      passwordConfirmation: ['', Validators.required]
    }, { validator: MustMatch('password', 'passwordConfirmation') });
  }

  changePassword() {
    this.resetpasswordService.ResetPasswordAsync(this.token, this.username, this.passwordform.get('password').value).subscribe(response => {
      this.display = true;
      this.type = 'passwordchanged';
    },
      error => {
        this.errorlist = error.error;
        this.type = 'error';
        this.display = true;
      });
  }

  continue() {
   // window.open('http://localhost:4200');
    this.login();
  }

   login(): void {
    this.oidcSecurityService.authorize();
  }
  cancel() {
    this.display = false;
  }

}
